import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconInvoiceSvg } from "./IconInvoiceSvg.mjs";
const IconInvoice = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconInvoiceSvg, ...svgProps }) });
export {
  IconInvoice
};
